var ko = require('knockout');
var $ = require('jquery');
var cart = require('_components/organisms/shopping-cart/shopping-cart-storage');
var analytics = require('_js/analytics-ecommerce');
require('knockout-postbox');

function CartViewModel(params) {
  var self = this;
  this.texts = params.texts;
  this.courseCatalogUrl = params.courseCatalogUrl;
  this.periodTotal = params.periodTotal;
  this.categoryHours = params.categoryHours;
  this.calculatorPageUrl = params.calculatorPageUrl;
  this.showCalculatorLink = ko.observable(true);
  this.showCalculator = ko.observable(true);
  // user should not see calculator if user does not have access or if not authorized accountant or auditor
  if (
    !window.isCalculatorAvailableForUser ||
    !(window.authorizedAccountant || window.authorizedAuditor)
  ) {
    this.showCalculator(false);
    this.showCalculatorLink(false);
  }

  if (params.redirectUrl === undefined) throw 'redirectUrl must be set';

  self.courses = ko.observableArray();

  self.deleteCourse = function(course) {
    cart.removeCourseFromCart(course.Id);
  };

  self.deleteCourseIfEnter = function(course, event) {
    if (event.key == 'Enter') {
      self.deleteCourse(course);
    }
  };

  self.totalHours = ko.computed(function() {
    var cart = self.courses();
    var hours = 0;
    for (var x = 0; cart.length < x; x++) {
      hours += cart[x].Hours;
    }
    return hours;
  });

  var updateVisualizationInMenu = function(cart) {
    var el = $('.support-menu-cart-visualisation');
    if (cart.courses !== undefined && cart.courses.length > 0) {
      el.addClass('is-active');
      el.find('.cart-visualisation-content').text(cart.courses.length);
    } else {
      el.removeClass('is-active');
    }
  };
  ko.postbox.subscribe(
    cart.updateTopic,
    function(newCart) {
      updateVisualizationInMenu(newCart);
      if (newCart.courses === undefined) {
        self.courses([]);
        return;
      }
      self.courses(newCart.courses);
    },
    true
  );

  self.addParticipants = function() {
    analytics.shoppingCartCheckedOut(1, cart.getCart(), params.redirectUrl);
  };

  self.deleteItemText = function(eventType) {
    if (eventType === 5) {
      return this.texts.deleteBundle;
    } else if (eventType === 6) {
      return this.texts.deleteProgram;
    }
    return this.texts.deleteCourse;
  };

  var wHeight = $(document).height(),
    $shoppingCart = $('.shopping-cart');

  var mainHeaderHeight = $('.main-header').height();

  $shoppingCart.innerHeight(wHeight - mainHeaderHeight);
}

module.exports = CartViewModel;
